export const TEMP_ID_NEW_CONVERSATION = 'new_chat'
export const AI_CHAT = 'aiChat'
export const IS_NEW_CONVERSATION = 'isNewConversation'

export const getNewChatObject = () => {
  return {
    id: TEMP_ID_NEW_CONVERSATION,
    modified: new Date().toISOString(),
    [IS_NEW_CONVERSATION]: true,
    messages: {
      results: [],
      paging: {}
    }
  }
}
